import { bdayPost, bdayGet, bdayPut, bdayDelete } from 'services/utils';
import { queryDictToString } from 'components/utils/query';

const baseApi = '/api/1/contact';
const baseContactsApi = '/api/1/contacts';

export const getContact = (contactId) => {
  return bdayGet(`${baseApi}?contactId=${contactId}`);
}
export const getContacts = (payload) => {
  const queryDictString = queryDictToString(payload);
  return bdayGet(`${baseContactsApi}${queryDictString}`);
}
export const checkContacts = (data) => {
  return bdayPost(`${baseApi}/check`, data);
}
export const addContacts = (data) => {
  return bdayPost(`${baseApi}`, data);
}
export const updateContacts = (data) => {
  return bdayPut(`${baseApi}`, data);
}
export const deleteContact = (data) => {
  return bdayDelete(`${baseApi}/${data.contactId}`, data);
}
